import { ReactNode } from "react";

import { ColorPaletteProps } from "~/bff/components/ColorPalette";
import { BreadcrumbsItem } from "~/bff/types/BreadcrumbsItem";
import { Docs } from "~/bff/types/Docs";
import { SearchResultsFound } from "~/bff/types/SearchResultsFound";
import { ShoppingTypeFilter } from "~/bff/types/ShoppingTypeFilter";
import { Store } from "~/bff/types/Store";
import { WidgetInfo } from "~/bff/types/WidgetInfo";
import { Nullable } from "~/types/general.types";
import { ProductRequestType } from "~/types/products-request-handler";

import {
  AppliedFilters,
  Filters,
  HandleFiltersCallback,
} from "./components/products-filters/types";

export const DEFAULT_PAGE_SIZE = 24;
export const FILTER_DIVIDER = "*";
export const SHOP_FILTER_KEY = "shopFilter";
export const SHOP_FILTER_DROPDOWN = "shopFilterDropdown";
export const MOCKED_SORTING_DROPDOWN_LABEL = "Sort by";
// Exclude temperature symbol *C and include only *
export const FILTER_DIVIDER_WITH_EXCLUDING = /(\*)(?!C\b)/;

const PRODUCTS_LAYOUT_CLASSES_PREFIX = "ProductsLayout";

export const PRODUCTS_LAYOUT_CLASSES = {
  productsLayoutContainer: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-container`,
  productListWrapper: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-productListWrapper`,
  topBar: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-topBar`,
  filterChipsContainer: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-filterChipsContainer`,
  filterChip: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-filterChip`,
  mobileShopFilter: `${PRODUCTS_LAYOUT_CLASSES_PREFIX}-mobileShopFilter`,
};

export interface ProductsLayoutProps {
  onLoadMore?: () => void;
  onLoadPrevious?: () => void;
  setActiveSortingParam?: (value: string) => void;
  activeSortingParam?: string;
  sortingParams: { value: string; text: Nullable<string> | undefined }[];
  isLoading?: boolean;
  totalCount: Nullable<number>;
  productsCaption?: ReactNode;
  products?: Nullable<Nullable<Docs>[]>;
  filtersData?: Filters;
  appliedFilters?: Nullable<AppliedFilters>;
  onFiltersClick?: HandleFiltersCallback;
  onAllFiltersClear?: () => void;
  onChipClick?: (filterName: string) => void;
  productFilterPanelText?: Nullable<string>;
  productSortSelectorText?: Nullable<string>;
  searchResultsFound?: Nullable<SearchResultsFound>;
  progressBarText?: Nullable<string>;
  productFilterClearAllButtonText?: Nullable<string>;
  loadMoreButtonText?: Nullable<string>;
  loadPreviousButtonText?: Nullable<string>;
  showPreviousButton: boolean;
  colorPalette: ColorPaletteProps;
  isShopFilter: Nullable<boolean>;
  currentStore: Nullable<Store>;
  onUpdateStore: (store: Nullable<Store>) => void;
  breadcrumbs?: Nullable<Nullable<BreadcrumbsItem>[]>;
  shopFilter: ShoppingTypeFilter;
  onShopFilterClick: (store: Nullable<Store>) => void;
  onShopFilterDropdown: (value: ProductRequestType) => void;
  setShopFilterSortingParam?: (value: ProductRequestType) => void;
  shopFilterSortingParam?: ProductRequestType;
  productToPageMap?: Map<string, number>;
  pageNumber?: React.RefObject<number>;
  restorationRef?: {
    markerId: Nullable<string>;
    scrollRestorationRef: React.RefObject<
      Nullable<HTMLSpanElement & HTMLAnchorElement>
    >;
  };
  shoppingTypeDropdown?: Nullable<boolean>;
  onShopFilterChipClick: () => void;
  widgetData?: Nullable<WidgetInfo>;
  numberItems?: number;
  sortOrderForGA?: string;
}
